import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../redux/store";
import axiosInstance from "../../../api/axiosInstance";
import endpoints from "../../../api/endpoints";

interface ChangePasswordState {
  loading: boolean;
  success: boolean;
  error: string | null;
}

const initialState: ChangePasswordState = {
  loading: false,
  success: false,
  error: null,
};

interface ChangePasswordInput {
  newPassword: string;
  confirmPassword: string;
  username: string;
}


export const changeUserPassword = createAsyncThunk(
  "auth/changeUserPassword",
  async (data: ChangePasswordInput, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const language = state.languageSlice.language;
    try {
      const response = await axiosInstance.post(
        endpoints.changePassword.changeUserPassword,
        data,
        {
          headers: {
            "Accept-Language": language,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message || "Failed to change password!");
      }
    }
  }
);

export const resteUserPassword = createAsyncThunk(
  "auth/resteUserPassword",
  async (data: ChangePasswordInput, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const language = state.languageSlice.language;
    try {
      const response = await axiosInstance.post(
        endpoints.restePassword.resteUserPassword,
        data,
        {
          headers: {
            "Accept-Language": language,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message || "Failed to reste password!");
      }
    }
  }
);

const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(changeUserPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeUserPassword.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(changeUserPassword.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || "Failed to change password!";
      })
      .addCase(resteUserPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resteUserPassword.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(resteUserPassword.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || "Failed to reste password!";
      });
  },
});

export default changePasswordSlice.reducer;
